import { LoadState } from "../../constants/enums";
import {
  IQuickReplyTemplate,
  IQuickReplyTemplateData,
  IQuickReplyTemplateState,
} from "./quickReplyTemplate.types";

export const initialQuickReplyTemplate: IQuickReplyTemplate = {
  company_outlet_uuid: "",
  company_outlet_name: "",
  name: null,
  status: null,
  reason: null,
  header: null,
  body: null,
  template_id: null,
  components: [],
  template_for: [],
  text: "",
};

export const INITIAL_QUICK_REPLY_TEMPLATE_DATA: IQuickReplyTemplateData = {
  name: "",
  category: "",
  components: [],
  example: {
    header_text: [],
    body_text: [],
  },
  header: {
    type: "HEADER",
    format: null,
    text: null,
    example: {
      header_text: [],
      header_handle: null,
    },
  },
  body: {
    type: "BODY",
    text: "",
    example: {
      body_text: [],
    },
  },
  buttons: {
    type: "BUTTONS",
    buttons: [],
  },
  footer: {
    type: "FOOTER",
    text: "",
  },

  company_outlet_uuid: "",
  quick_reply_uuid: null,
  text: "",
};

export const initialQuickReplyTemplateData: IQuickReplyTemplateData = {
  company_outlet_uuid: "",
  name: "",
  category: "MARKETING",
  template_for: [],
  example: {
    header_text: [],
    body_text: [],
  },
  components: [],
  header: {
    type: "HEADER",
    format: null,
    text: null,
    example: {
      header_text: [],
      header_handle: null,
    },
  },
  body: {
    type: "BODY",
    text: "",
    example: {
      body_text: [],
    },
  },
  buttons: {
    type: "BUTTONS",
    buttons: [],
  },
  footer: {
    type: "FOOTER",
    text: "",
  },
  quick_reply_uuid: null,
  text: "",
  status: "ACTIVE",
};

export const initialQuickReplyTemplateState: IQuickReplyTemplateState = {
  list: {
    list: [],
    // Old paging property removed (kept for reference)
    // paging: {
    //   cursors: {
    //     after: "",
    //     before: "",
    //   },
    //   next: "",
    //   itemPerPage: 0,
    // },
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  quickReplyTemplate: {
    data: initialQuickReplyTemplate,
    loading: LoadState.NotLoaded,
    error: null,
  },
  quickReplyTemplateData: {
    data: initialQuickReplyTemplateData,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
